export const setLocalStateMailboxId = (id: string): void => {
    localStorage.setItem('mailboxId', id);
};

export const setSessionStateFolderId = (id: string): void => {
    sessionStorage.setItem('selectedFolderId', id);
};
